import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import aboutImage from '../assets/about.webp';

const About: React.FC = () => {
  const { t } = useTranslation();

  const animationVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        yoyo: Infinity,
        repeatDelay: 0.5
      }
    }
  };

  return (
    <section className="py-20 bg-gray-50" id="about">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-4xl font-bold text-center mb-12 text-gradient"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {t('about.title')}
        </motion.h2>
        <div className="flex flex-wrap items-center">
          <motion.div
            className="w-full md:w-1/2 mb-8 md:mb-0"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <img
              src={aboutImage}
              alt="About eAlice"
              className="w-full h-auto rounded-lg shadow-xl animate-float"
            />
          </motion.div>
          <motion.div
            className="w-full md:w-1/2 md:pl-12"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              {t('about.description')}
            </p>
            <motion.div
              className="flex justify-center items-center"
              variants={animationVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <svg className="w-16 h-16 text-blue-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                <path d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;